import type { DataProvider } from "@refinedev/core";
import { createKernelDataProvider, createMCPDataProvider } from "@evo-flywheel/ui";
import { coreBOSMap } from "@kit/corebos-map";
import { COREBOS_API_URL, KERNEL_API_URL } from "./config";

const kernel = createKernelDataProvider(KERNEL_API_URL, "");
const corebos = createMCPDataProvider(COREBOS_API_URL);
const corebosResource = <T extends { resource: string }>(params: T): T => ({
  ...params,
  resource: coreBOSMap[params.resource]?.coreBOSModule ?? params.resource,
});

const cqrs: DataProvider = {
  getList: (params) => kernel.getList(params),
  getOne: (params) => kernel.getOne!(params),
  getMany: (params) => kernel.getMany!(params),
  create: (params) => corebos.create(corebosResource(params)),
  update: (params) => corebos.update(corebosResource(params)),
  deleteOne: (params) => corebos.deleteOne!(corebosResource(params)),
  custom: (params) => kernel.custom!(params),
  getApiUrl: () => KERNEL_API_URL,
};

export const dataProvider = { default: cqrs, kernel, corebos };
